import React from 'react';
export function ArticleFooter() {
  return <footer className="bg-[#1B1B2F] text-white py-12 mt-16" data-id="element-62">
      <div className="max-w-5xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8 text-sm" data-id="element-63">
        <div data-id="element-64">
          <h3 className="font-serif text-2xl mb-4" data-id="element-65">EvidentiaMed</h3>
          <p className="text-gray-400 mb-4" data-id="element-66">
            Ihr Portal für wertvolle Informationen rund um Gesundheit und
            Wohlbefinden.
          </p>
          <p className="text-gray-500 text-xs" data-id="element-67">
            © 2026 EvidentiaMed Publications. Alle Rechte vorbehalten.
          </p>
        </div>

        <div data-id="element-68">
          <h4 className="font-bold uppercase tracking-wider mb-4 text-gray-300" data-id="element-69">
            Redaktion
          </h4>
          <ul className="space-y-2 text-gray-400" data-id="element-70">
            <li data-id="element-71">Über uns</li>
            <li data-id="element-72">Unsere Experten</li>
            <li data-id="element-73">Redaktionelle Richtlinien</li>
            <li data-id="element-74">Kontakt</li>
            <li data-id="element-75">Karriere</li>
          </ul>
        </div>

        <div data-id="element-76">
          <h4 className="font-bold uppercase tracking-wider mb-4 text-gray-300" data-id="element-77">
            Rechtliches
          </h4>
          <ul className="space-y-2 text-gray-400" data-id="element-78">
            <li data-id="element-79">Impressum</li>
            <li data-id="element-80">Datenschutz</li>
            <li data-id="element-81">Nutzungsbedingungen</li>
            <li data-id="element-82">Cookie-Einstellungen</li>
            <li data-id="element-83">Haftungsausschluss</li>
          </ul>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 mt-8 pt-4 border-t border-[#222240]" data-id="element-84">
        <p className="text-xs leading-relaxed text-gray-400" data-id="element-85">
          Wichtiger Hinweis: Die auf dieser Webseite dargestellte Geschichte von
          Anna M. sowie die Person des "Dr. Lippert" sind fiktive Charaktere,
          die zu Marketingzwecken erstellt wurden, um die Bedeutung der
          richtigen Nährstoffkombination zu veranschaulichen. Die Inhalte dienen
          ausschließlich der Information und Unterhaltung und stellen keine
          medizinische Beratung, Diagnose oder Behandlung dar. Die Ergebnisse
          können variieren und sind nicht garantiert. Nahrungsergänzungsmittel
          sind kein Ersatz für eine ausgewogene Ernährung und eine gesunde
          Lebensweise. Vor der Einnahme jeglicher Präparate konsultieren Sie
          bitte Ihren Arzt.
        </p>
      </div>
    </footer>;
}